export default "__VITE_ASSET__BvFvYUyS__"